import React from "react";
import logo from "@assets/svgs/logo.svg";
import styles from "./styles/AuthHeader.module.css";
import { useNavigate } from "react-router-dom";

const AuthHeader = () => {
  const navigate = useNavigate();

  return (
    <div
      className={styles.header}
      onClick={() => {
        navigate("/");
      }}
    >
      <img src={logo} alt="logo" height={32} width={135} />
    </div>
  );
};

/* required: display name */
AuthHeader.displayName = "AuthHeader";

/* required: props types */
AuthHeader.propTypes = {};

/* required: default props */
AuthHeader.defaultProps = {};

export { AuthHeader };
